import { render, staticRenderFns } from "./ETextarea2.vue?vue&type=template&id=bd0cfe92&scoped=true"
import script from "./ETextarea2.vue?vue&type=script&lang=js"
export * from "./ETextarea2.vue?vue&type=script&lang=js"
import style0 from "./ETextarea2.vue?vue&type=style&index=0&id=bd0cfe92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0cfe92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd0cfe92')) {
      api.createRecord('bd0cfe92', component.options)
    } else {
      api.reload('bd0cfe92', component.options)
    }
    module.hot.accept("./ETextarea2.vue?vue&type=template&id=bd0cfe92&scoped=true", function () {
      api.rerender('bd0cfe92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ETextarea2.vue"
export default component.exports